export default __webpack_public_path__ + "static/rovo-menu-do-light-d5ccf67f4db6cb42db710e1e6c3f1a07.png";